import * as THREE from 'three';
import { createPremiumCharacter } from '../engine/entities/quaternius-characters.js';
import type { FloorLayoutModule } from '../floor/dynamic-floor.js';
import { PilotServiceScenario } from './pilot-service-scenario.js';

export class PremiumPilotController {
  readonly root = new THREE.Group();
  private scenario: PilotServiceScenario | null = null;
  private ready = false;
  private layout: FloorLayoutModule[] = [];

  static async mount(parent: THREE.Group): Promise<PremiumPilotController> {
    const ctrl = new PremiumPilotController();
    parent.add(ctrl.root);
    try {
      const [waiter, client] = await Promise.all([
        createPremiumCharacter('waiter'),
        createPremiumCharacter('client'),
      ]);
      ctrl.root.add(waiter.root, client.root);
      ctrl.scenario = new PilotServiceScenario(client, waiter);
      ctrl.ready = true;
    } catch (e) {
      console.warn('[CL-VIVO-009] Personajes premium no cargados:', e);
    }
    return ctrl;
  }

  setLayout(layout: FloorLayoutModule[]): void {
    this.layout = layout;
    if (this.ready && this.scenario) this.scenario.reset(layout);
  }

  restart(): void {
    if (this.ready && this.scenario) this.scenario.reset(this.layout);
  }

  isReady(): boolean {
    return this.ready;
  }

  update(dt: number): void {
    this.scenario?.update(dt);
  }
}
